<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3">
        <v-icon>{{ $route.meta.icon }}</v-icon>
        {{ title || $route.meta.title }}
      </h3>
    </div>
    <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>
    <v-spacer></v-spacer>
    <div class="page-header-right">
      <slot name="actions"></slot>

      <v-flex d-inline-flex v-if="$route.meta.autoRefresh">
        <v-select
          dense
          :items="autoRefreshItems"
          :label="$t('autoRefresh.text')"
          v-model="autoRefreshTimeModel"
        ></v-select>
      </v-flex>

      <v-btn icon v-if="$route.meta.hideRefreshButton !== true">
        <v-icon class="text--secondary" @click="clickRefresh">refresh</v-icon>
      </v-btn>
      <v-tooltip
        bottom
        v-if="
          typeof $route.meta.addButton === 'object' &&
            'tooltip' in $route.meta.addButton &&
            checkAddButton($route.meta.addButton)
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn fab dark small color="success" v-on="on" @click="clickAdd">
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <span>{{ $route.meta.addButton.tooltip }}</span>
      </v-tooltip>
      <v-btn
        fab
        dark
        small
        color="success"
        v-else-if="checkAddButton($route.meta.addButton)"
        @click="clickAdd"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import {
  CLICK_CREATE_BUTTON,
  CLICK_REFRESH_BUTTON,
  CHANGE_AUTO_REFRESH_TIME
} from "@/store/actions.type";

export default {
  props: {
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      autoRefreshItems: [
        {
          value: 0,
          text: this.$t("never")
        },
        {
          value: 10000,
          text: this.$t("autoRefresh.period10seconds")
        },
        {
          value: 30000,
          text: this.$t("autoRefresh.period30seconds"),
          selected: true
        },
        {
          value: 60000,
          text: this.$t("autoRefresh.period1minute")
        },
        {
          value: 300000,
          text: this.$t("autoRefresh.period5minutes")
        }
      ]
    };
  },
  computed: {
    breadcrumbs: function() {
      let breadcrumbs = [];
      // menu.forEach(item => {
      //   if (item.items) {
      //     let child = item.items.find(i => {
      //       return i.component === this.$route.name;
      //     });
      //     if (child) {
      //       breadcrumbs.push(item.title);
      //       breadcrumbs.push(child.title);
      //       this.title = child.title;
      //       this.icon = child.icon;
      //     }
      //   } else {
      //     if (item.name === this.$route.name) {
      //       this.title = item.title;
      //       this.icon = item.icon;
      //       breadcrumbs.push(item.title);
      //     }
      //   }
      // });
      return breadcrumbs;
    },
    ...mapGetters(["autoRefreshTime"]),
    autoRefreshTimeModel: {
      get() {
        return this.autoRefreshTime;
      },
      set(value) {
        this.$store.dispatch(CHANGE_AUTO_REFRESH_TIME, value);
      }
    }
  },
  methods: {
    clickRefresh() {
      this.$store.dispatch(CLICK_REFRESH_BUTTON);
    },
    clickAdd() {
      this.$store.dispatch(CLICK_CREATE_BUTTON);
    },
    checkAddButton: function(properties) {
      let decision = false;
      if (typeof properties === "object" && properties.allowed) {
        decision = true;

        // eslint-disable-next-line no-prototype-builtins
        if (properties.hasOwnProperty("permission")) {
          decision = this.$store.getters.hasPermission(properties.permission);
        }
      }

      return decision;
    }
  }
};
</script>
